<template>
<md-layout md-gutter class="main_layout" md-align="center">
    <md-layout md-flex="15"></md-layout>
    <md-layout  md-column md-gutter md-align="center">
    
    <router-link to="/">
      <img src='../assets/chemistryAI_logo.png' style="height: 77px; width:265px; margin:50px 0 0 0;"/>
    </router-link> 
    
    <span class="md-display-2" style="margin:100px 0; ">RESULTS OF YOUR TEST</span>
    <md-layout md-align="center">
      <md-layout md-column>
       <md-layout style="max-height: 110px; " md-align="center">
        
          <h2 style="color:#6faa43 !important">HUMAN MOLECULES</h2>
        
        </md-layout>
        <md-layout>
    	<ul >
        <li v-for="human in filterHuman" v-bind:key="human.id" class="results-list-item">
          <md-card>
            <md-card-media-cover>
            <md-card-media>
              <img :src="'/static/mol/'+human.name+'.png'"  style="width:100%; height: auto;" v-bind:class="{ liked: moleculeLiked(human)}"/>
            </md-card-media>
            <!-- <md-card-area> -->
              <center>
                <div v-if="emotive()" class="emotions">
                  <span class="md-title">Interest: <strong> {{ moleculeInterestValue(human) }} % </strong></span>
                  <span class="md-title">Excitement: <strong> {{ moleculeExcitementValue(human) }} % </strong></span>
                  <span class="md-title">Stress: <strong>{{ moleculeStressValue(human) }} % </strong></span>
                </div>
              </center>
            <!-- </md-card-area> -->
            </md-card-media-cover>
          </md-card>
        </li>
    	</ul>
        </md-layout>
      </md-layout>
      <md-layout md-column>
       <md-layout style="max-height: 110px; " md-align="center">
        
          <h2 style="color: #58b1df !important;">GAN MOLECULES</h2>
        
        </md-layout>
        <md-layout>
        <ul>
        <li v-for="gan in filterGAN" v-bind:key="gan.id" class="results-list-item">
          <md-card>
            <md-card-media-cover>
            <md-card-media>
              <img :src="'/static/mol/'+gan.name+'.png'"  style="width:100%; height: auto;" v-bind:class="{ liked: moleculeLiked(gan)}"/>
            </md-card-media>
            <!-- <md-card-area> -->
            <center>
              <div v-if="emotive()" class="emotions">
                <span class="md-title">Interest: <strong> {{ moleculeInterestValue(gan) }} % </strong></span>
                <span class="md-title">Excitement: <strong> {{ moleculeExcitementValue(gan) }} % </strong> </span>
                <span class="md-title">Stress: <strong> {{ moleculeStressValue(gan) }} % </strong></span>
              </div>
            </center>
            <!-- </md-card-area> -->
            </md-card-media-cover>
          </md-card>
        </li>
        </ul>
        </md-layout>
      </md-layout>
    </md-layout>
    </md-layout>
    
    <md-layout md-flex="15"></md-layout>
    
</md-layout>


</template>

<script>
var toPersentString = (num) => {
    try {
        return (num * 100).toFixed().toString()
    } catch (e) {
        return '-'
    }
}

export default {
	  name: 'experiment-result',
	  props: [],
	  data () {
	      return {
	          msg: 'Welcome to Your Vue.js App'
	      }
	  },
	  computed:{
		    molecules(){
			      return this.$store.state.molecules
		    },
		    filterGAN(){
			      return this.molecules.filter(mol =>{
				        return mol.design > 0
			      })
		    },
		    filterHuman(){
			      return this.molecules.filter(mol =>{
				        return mol.design < 1
			      })
		    }
	  },
	  methods: {
		    moleculeLiked : function(molecule){
			      
            if(this.$store.state.experiment.exp_type==0) return molecule.guess == 0 //like = 0
            else if (this.$store.state.experiment.exp_type==2) return false
			      else return molecule.design === molecule.guess 
        },
        emotive() {
            return this.$store.state.experiment.exp_type == 2
        },
        moleculeInterestValue: function (mol) {
            return toPersentString(mol.data[0])
        },
        moleculeExcitementValue: function (mol) {
            return toPersentString(mol.data[3])
        },
        moleculeStressValue: function (mol) {
            return toPersentString(mol.data[1])
        }
	      },
	 beforeCreate(){
	    	  let experiment_id = this.$route.params.id
	    	  this.$store.dispatch('getExperiment', experiment_id)
	      }
	    
	    
	}


</script>

<style scoped>
.res_main_layout {}
.main_layout{
  background-image: url('../assets/top-element.png');
  background-position:  top left, bottom right ;
  background-repeat: no-repeat, no-repeat;
  height:100%;
  
}
h2 {
  color:#eb8d00;
  font-size: 2vw;
  line-height: 1.23;
  
}
.top_button {
  font-size: 25px;
  padding: 10px;
  border-radius: 5px;
  color: #fff !important;
  width: 300px;
  cursor: default;
  margin-bottom:50px;
  margin-left: 43px;
}
.human_button {
  background-color: #6faa43 !important;
}
.gan_button {
  background-color: #58b1df !important;
}
ul {
  list-style:none;
  height: 100%;
}
.liked{
  border:4px solid #6faa43;
}
.emotions span {
  padding-right: 10px;
  color: black;
}
.results-list-item {
  margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// ExperimentResult.vue?faaff8c6